module.exports = __webpack_public_path__ + "static/media/pilates-pro-works.3ad2f3fe.png";